import { useTonWallet } from "@tonconnect/ui-react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { Link, useNavigate } from "react-router-dom";
import useFriendlyAddress from "../../../../../../hooks/useFriendlyAddress";
import { NFTLendingIcon } from "../../../../../../pages/NFTPage/ui/components/NFTPageActivity/components/Icons/NFTLending";
import CloseIcon from "../../../../../Icons/CloseIcon";
import LogoutIcon from "../../../../../Icons/LogoutIcon";
import TelegramIcon from "../../../../../Icons/TelegramIcon";
import TwitterIcon from "../../../../../Icons/TwitterIcon";
import UserIcon from "../../../../../Icons/UserIcon";
import MainHeaderStore from "../../../../stores/MainHeaderStore";
import useMobMenu from "../helpers/useMobMenu";
import s from "./MobMenu.module.scss";

interface Props {
  store: MainHeaderStore;
  lockBodyScroll: () => void;
  unlockBodyScroll: () => void;
}

const socItems = [
  {
    link: "https://t.me/ooiaton",
    icon: <TelegramIcon color="#0D0C21" />,
  },
  {
    link: "https://t.me/ooiatonbot",
    icon: <TelegramIcon color="#0D0C21" />,
  },
  {
    link: "https://t.me/ooiaton_ru",
    icon: <TelegramIcon color="#0D0C21" />,
  },
  {
    link: "https://x.com/OoiaTon",
    icon: <TwitterIcon color="#0D0C21" />,
  },
];

export const MobMenu: React.FC<Props> = observer(
  ({ store, lockBodyScroll, unlockBodyScroll }) => {
    const { logoutClick, closeMenu, navigateToLendings } = useMobMenu({
      store,
      lockBodyScroll,
      unlockBodyScroll,
    });
    const wallet = useTonWallet();
    const userAddress = useFriendlyAddress(wallet?.account.address);
    const navigate = useNavigate();
    const profileOnClick = () => {
      navigate(`/user/${userAddress}`);
      closeMenu();
    };

    const lendingOnClick = () => {
      navigate(`/lendings`);
      closeMenu();
    };
    return (
      <div className={clsx(s.wrapper, store.isMenuMobOpen && s.active)}>
        <div className={s.close} onClick={closeMenu}>
          <CloseIcon />
        </div>
        <div className={s.links}>
          <div onClick={profileOnClick} className={s.link}>
            <UserIcon />
            <span>Profile</span>
          </div>
          <div onClick={lendingOnClick} className={s.link}>
            <NFTLendingIcon />
            <span>Lendings</span>
          </div>
          <div className={s.link} onClick={logoutClick}>
            <LogoutIcon />
            <span>Log Out</span>
          </div>
        </div>
        <div className={s.socs}>
          {socItems.map((item, i) => (
            <Link target="blank" to={item.link} className={s.soc} key={i}>
              {item.icon}
            </Link>
          ))}
        </div>
      </div>
    );
  }
);
